import options from './create-notification.component';

export default {
    selector: 'dtAlertsActionsCreateNotification',
    options
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/actions/create-notification/index.js